var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStars(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11421_20280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.76818 13.2465V10.3078M2.76818 4.43041V1.4917M1.29883 2.96105H4.23753M1.29883 11.7772H4.23753M7.76398 2.07944L6.74484 4.72957C6.5791 5.16038 6.49623 5.37608 6.36692 5.55711C6.25281 5.71784 6.11255 5.8583 5.95198 5.97264C5.77095 6.10135 5.55525 6.18423 5.12444 6.34997L2.47431 7.36911L5.12444 8.38826C5.55525 8.554 5.77095 8.63687 5.95198 8.76617C6.11243 8.8802 6.2529 9.02067 6.36751 9.18112C6.49622 9.36214 6.5791 9.57784 6.74484 10.0087L7.76398 12.6588L8.78313 10.0087C8.94887 9.57784 9.03174 9.36214 9.16104 9.18112C9.27507 9.02067 9.41554 8.8802 9.57599 8.76559C9.75701 8.63687 9.97271 8.554 10.4035 8.38826L13.0537 7.36911L10.4035 6.34997C9.97271 6.18423 9.75701 6.10135 9.57599 5.97264C9.41542 5.8583 9.27516 5.71784 9.16104 5.55711C9.03174 5.37608 8.94946 5.16038 8.78313 4.72957L7.76398 2.07944Z",
    stroke: "white",
    strokeWidth: 1.17548,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11421_20280"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.1058,
    height: 14.1058,
    fill: "white",
    transform: "translate(0.123047 0.316406)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.1757c4b5e3b283a79ba6f0cec1cf9ef2.svg";
export { ForwardRef as ReactComponent };